import script from "./LogoImg.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoImg.vue?vue&type=script&setup=true&lang=js"

import "./LogoImg.vue?vue&type=style&index=0&id=213505bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-213505bc"]])

export default __exports__